export const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export const todayDateField = () => {
  var today = new Date()
  var dd = String(today.getDate()).padStart(2, '0')
  var mm = String(today.getMonth() + 1).padStart(2, '0')
  var yyyy = today.getFullYear()

  return `${yyyy}-${mm}-${dd}`
}

export const thirteenYearsAgoDateField = () => {
  var thirteenYearsAgo = new Date()
  thirteenYearsAgo.setFullYear(thirteenYearsAgo.getFullYear() - 13)
  var dd = String(thirteenYearsAgo.getDate()).padStart(2, '0')
  var mm = String(thirteenYearsAgo.getMonth() + 1).padStart(2, '0')
  var yyyy = thirteenYearsAgo.getFullYear()

  return `${yyyy}-${mm}-${dd}`
}

export const diffYearsFromNow = (date) => {
  const now = new Date()
  const now_year = now.getFullYear()
  const date_year = date.getFullYear()

  var diff = now_year - date_year

  return diff
}

export const diffMinutesApart = (date1, date2) => {
  var diff = (date2.getTime() - date1.getTime()) / 1000
  diff /= 60
  return Math.abs(Math.round(diff))
}

export const featuredDate = (featured_date) => {
  let date = new Date(featured_date)

  if (typeof featured_date === 'number') {
    date = new Date(featured_date * 1000)
  }

  const options = { year: 'numeric', month: 'long', day: 'numeric' }
  return date.toLocaleDateString('en-US', options)
}

export const fullDate = (timestamp) => {
  let date = new Date(timestamp)

  if (typeof timestamp === 'number') {
    date = new Date(timestamp * 1000)
  }

  const date_options = { year: 'numeric', month: 'long', day: 'numeric' }
  const date_string = date.toLocaleString('default', date_options)

  return date_string
}

export const fullDateTime = (timestamp) => {
  let date = new Date(timestamp)

  if (typeof timestamp === 'number') {
    date = new Date(timestamp * 1000)
  }

  const date_options = { year: 'numeric', month: 'long', day: 'numeric' }
  const date_string = date.toLocaleString('default', date_options)

  const time_options = { hour: 'numeric', minute: 'numeric' }
  const time_string = date.toLocaleString('default', time_options)

  const is_english = typeof navigator !== 'undefined' ? navigator.language.indexOf('en') > -1 : true

  return is_english ? `${date_string} at ${time_string}` : `${date_string} - ${time_string}`
}

export const timeAgo = (dateParam) => {
  if (!dateParam) {
    return null
  }

  const is_english = typeof navigator !== 'undefined' ? navigator.language.indexOf('en') > -1 : true

  const getFormattedDate = (date, prefomattedDate = false, hideYear = false) => {
    const day = date.getDate()
    const month = date.toLocaleString('default', { month: 'short' })
    const year = date.getFullYear()
    const hours = date.getHours()
    let minutes = date.getMinutes()
    const time = date.toLocaleString('default', {
      minute: 'numeric',
      hour: 'numeric',
      hour12: true,
    })

    if (minutes < 10) {
      // Adding leading zero to minutes
      minutes = `0${minutes}`
    }

    if (prefomattedDate) {
      // Today at 10:20
      // Yesterday at 10:20
      return `${prefomattedDate} - ${time}`
    }

    if (hideYear) {
      // January 10 - 10:20
      return date.toLocaleString('default', { month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' })
    }

    // January 10  10:20
    return date.toLocaleString('default', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    })
  }

  const date = typeof dateParam === 'object' ? dateParam : new Date(dateParam)
  const DAY_IN_MS = 86400000 // 24 * 60 * 60 * 1000
  const today = new Date()
  const yesterday = new Date(today - DAY_IN_MS)
  const seconds = Math.round((today - date) / 1000)
  const minutes = Math.round(seconds / 60)
  const hours = Math.round(minutes / 60)
  const isToday = today.toDateString() === date.toDateString()
  const isYesterday = yesterday.toDateString() === date.toDateString()
  const isThisYear = today.getFullYear() === date.getFullYear()

  if (seconds < 15) {
    return 'now'
  } else if (seconds < 60) {
    return `${seconds} seconds ago`
  } else if (seconds < 100) {
    return 'about a minute ago'
  } else if (minutes < 60) {
    return `${minutes} minutes ago`
  } else if (minutes < 1440) {
    return `${hours} hours ago`
  } else if (isToday) {
    return getFormattedDate(date, is_english ? 'Today' : '') // Today at 10:20
  } else if (isYesterday) {
    return getFormattedDate(date, is_english ? 'Yesterday' : '') // Yesterday at 10:20
  } else if (isThisYear) {
    return getFormattedDate(date, false, true) // 10. January at 10:20
  }

  return getFormattedDate(date) // 10. January 2017. at 10:20
}
